// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../common/Components/IconV5.bs.js");
let V4 = require("uuid/v4");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Belt_SortArray = require("@rescript/runtime/lib/js/Belt_SortArray.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Primitive_string = require("@rescript/runtime/lib/js/Primitive_string.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let NotificationSettingsBuyerNeeds = require("./NotificationSettingsBuyerNeeds.bs.js");
let NotificationSettingsComponents = require("./NotificationSettingsComponents.bs.js");
let NotificationSettingsRentalNeeds = require("./NotificationSettingsRentalNeeds.bs.js");
let NotificationSettings_areas_graphql = require("../../__generated__/NotificationSettings_areas_graphql.bs.js");
let NotificationSettingsNewDevelopments = require("./NotificationSettingsNewDevelopments.bs.js");
let NotificationSettingsRentalProperties = require("./NotificationSettingsRentalProperties.bs.js");
let NotificationSettings_chapter_graphql = require("../../__generated__/NotificationSettings_chapter_graphql.bs.js");
let NotificationSettingsBroadcastMessages = require("./NotificationSettingsBroadcastMessages.bs.js");
let NotificationSettingsForSaleProperties = require("./NotificationSettingsForSaleProperties.bs.js");
let NotificationSettings_userNotificationSettings_graphql = require("../../__generated__/NotificationSettings_userNotificationSettings_graphql.bs.js");

let convertFragment = NotificationSettings_userNotificationSettings_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettings_userNotificationSettings_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettings_userNotificationSettings_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettings_userNotificationSettings_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettings_userNotificationSettings_graphql.node, convertFragment, fRef);
}

let UserNotificationSettingsFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let areaTypeV5_decode = NotificationSettings_areas_graphql.Utils.areaTypeV5_decode;

let convertFragment$1 = NotificationSettings_areas_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettings_areas_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettings_areas_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, NotificationSettings_areas_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettings_areas_graphql.node, convertFragment$1, fRef);
}

let AreasFragment_areaTypeV5_fromString = NotificationSettings_areas_graphql.Utils.areaTypeV5_fromString;

let AreasFragment = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: AreasFragment_areaTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function mapCensusPlaceTypeToCityTypeOpt(x) {
  if (x === "CENSUS_PLACE") {
    return "CITY";
  } else {
    return x;
  }
}

function NotificationSettings$ExpandedAreas(props) {
  let style = props.style;
  let areas = RescriptRelay_Fragment.useFragment(NotificationSettings_areas_graphql.node, convertFragment$1, props.areas);
  let areaTypesOrder = [
    "BLOCK_GROUP",
    "NEIGHBORHOOD",
    "SCHOOL_DISTRICT",
    "SCHOOL",
    "TOWNSHIP",
    "ZIP_CODE",
    "CITY",
    "COUNTY",
    "STATE"
  ];
  let groupedByType = Stdlib_Array.reduce(areas, {}, (acc, area) => {
    let areaType = mapCensusPlaceTypeToCityTypeOpt(areaTypeV5_decode(area.type_));
    if (areaType === undefined) {
      return acc;
    }
    let current = Stdlib_Option.getOr(acc[areaType], []);
    current.push({
      id: area.id,
      label: area.label,
      type_: areaType
    });
    let current$1 = Belt_SortArray.stableSortBy(current, (a, b) => Primitive_string.compare(a.label, b.label) | 0);
    acc[areaType] = current$1;
    return acc;
  });
  return JsxRuntime.jsx("div", {
    children: areaTypesOrder.map(areaType => {
      let areas = groupedByType[areaType];
      if (areas !== undefined) {
        return JsxRuntime.jsx(NotificationSettingsComponents.AreaTypesList.make, {
          areas: areas,
          areaType: areaType,
          style: style
        });
      } else {
        return null;
      }
    })
  });
}

let ExpandedAreas = {
  AreasFragment: AreasFragment,
  mapCensusPlaceTypeToCityTypeOpt: mapCensusPlaceTypeToCityTypeOpt,
  make: NotificationSettings$ExpandedAreas
};

let convertFragment$2 = NotificationSettings_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettings_chapter_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettings_chapter_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettings_chapter_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettings_chapter_graphql.node, convertFragment$2, fRef);
}

let ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function NotificationSettings(props) {
  let userNotificationSettings = RescriptRelay_Fragment.useFragment(NotificationSettings_userNotificationSettings_graphql.node, convertFragment, props.userNotificationSettings);
  let chapter = RescriptRelay_Fragment.useFragment(NotificationSettings_chapter_graphql.node, convertFragment$2, props.chapter);
  let match = React.useState(() => false);
  let setIsExpanded = match[1];
  let isExpanded = match[0];
  let match$1 = SystemMessages.useSystemMessages();
  let addMessage = match$1.addMessage;
  let handleFailure = () => addMessage(SystemMessages.Message.make(V4(), "error", "There was an error updating your preferences", 5000, undefined, undefined));
  let handleSuccess = () => addMessage(SystemMessages.Message.make(V4(), "info", "Updated notification settings", 5000, undefined, undefined));
  let match$2 = chapter.notificationPreferences;
  let chapterDefaultAreas;
  if (match$2 !== undefined) {
    let defaultPropertyNotificationAreas = match$2.defaultPropertyNotificationAreas;
    chapterDefaultAreas = defaultPropertyNotificationAreas !== undefined ? defaultPropertyNotificationAreas : undefined;
  } else {
    chapterDefaultAreas = undefined;
  }
  let numberOfAreas = Stdlib_Option.getOr(chapterDefaultAreas, []).length;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
              children: "By default, you receive all broadcasts in your chapter area(s). Customize your filters if you wish to get emails from outside your chapter area(s) or to tailor what you receive by location, price and more."
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                  onClick: param => setIsExpanded(prev => !prev),
                  size: "small",
                  className: "hover:underline justify-normal",
                  ariaExpanded: isExpanded,
                  children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("span", {
                        children: JsxRuntime.jsx(IconV5.make, {
                          icon: isExpanded ? "arrow-up" : "arrow-down",
                          size: 14
                        }),
                        "aria-hidden": true
                      }),
                      JsxRuntime.jsx("span", {
                        children: isExpanded ? `Hide ` + Stdlib_Option.getOr(chapter.displayName, "") + ` chapter areas (` + numberOfAreas.toString() + `)` : `Show ` + Stdlib_Option.getOr(chapter.displayName, "") + ` chapter areas (` + numberOfAreas.toString() + `)`
                      })
                    ],
                    className: "flex flex-row gap-2 items-center text-base text-gray-600"
                  })
                }),
                isExpanded && chapterDefaultAreas !== undefined ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(NotificationSettings$ExpandedAreas, {
                      areas: chapterDefaultAreas.map(v => v.fragmentRefs)
                    }),
                    className: "mt-2"
                  }) : null
              ],
              className: "flex flex-col gap-1"
            })
          ],
          className: "space-y-4 flex flex-col"
        }),
        className: "max-w-2xl"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(NotificationSettingsForSaleProperties.make, {
          notificationSetting: userNotificationSettings.fragmentRefs,
          onSuccess: handleSuccess,
          onFailed: handleFailure,
          chapter: chapter.fragmentRefs
        })
      }),
      props.includeDevelopments ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(NotificationSettingsNewDevelopments.make, {
            notificationSetting: userNotificationSettings.fragmentRefs,
            onSuccess: handleSuccess,
            onFailed: handleFailure,
            chapter: chapter.fragmentRefs
          })
        }) : null,
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(NotificationSettingsRentalProperties.make, {
          notificationSetting: userNotificationSettings.fragmentRefs,
          onSuccess: handleSuccess,
          onFailed: handleFailure,
          chapter: chapter.fragmentRefs
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(NotificationSettingsBuyerNeeds.make, {
          notificationSetting: userNotificationSettings.fragmentRefs,
          onSuccess: handleSuccess,
          onFailed: handleFailure,
          chapter: chapter.fragmentRefs
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(NotificationSettingsRentalNeeds.make, {
          notificationSetting: userNotificationSettings.fragmentRefs,
          onSuccess: handleSuccess,
          onFailed: handleFailure,
          chapter: chapter.fragmentRefs
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(NotificationSettingsBroadcastMessages.make, {
          notificationSetting: userNotificationSettings.fragmentRefs,
          onSuccess: handleSuccess,
          onFailed: handleFailure
        })
      })
    ],
    className: "flex flex-col space-y-2"
  });
}

let make = NotificationSettings;

exports.UserNotificationSettingsFragment = UserNotificationSettingsFragment;
exports.ExpandedAreas = ExpandedAreas;
exports.ChapterFragment = ChapterFragment;
exports.make = make;
/* react Not a pure module */
